import React, {useCallback, useContext, useMemo, useState} from "react";
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {AuthContext} from "../../../../shared/contexts/authContext";
import {Tag, Button, Space, Card} from "antd";
import {Datatable} from "../../../../shared/components/datatable/Datatable";
import {useBookMainTBL} from "../../../probability/useItemData";

const COLLECTION_TYPE = {
    COLLECTION: 1,
    CONNECTION: 2,
};

const getCollectionData = (playerData) => {
    const collection = playerData.playerInfo?.collectionContentsData?.CollectionRewards || [];
    const keys = Object.keys(collection);
    const data = [];
    keys.forEach(key => {
        Object.values(collection[key]).forEach(value => {
            data.push({
                category: key,
                index: value.CollectionIndex,
                group: 0,
                state: value.CollectionRewardState,
            })
        });
    });
    return data;
}
const getConnectData = (playerData) => {
    const connect = playerData.playerInfo?.connectContentsData || {};
    const keys = Object.keys(connect);
    const data = [];
    keys.forEach(category => {
        const groups = Object.keys(connect[category]);
        groups.forEach(group => {
            Object.values(connect[category][group].RewardData).forEach(value => {
                data.push({
                    category,
                    index: value.ConnectRewardIndex,
                    group,
                    state: value.ConnectRewardState,
                })
            });
        });
    });
    return data
}

const Collection = () => {
    const {playerData} = useContext(PlayerContext);
    const {currentUser} = useContext(AuthContext);
    const {data: bookMainTBLData} = useBookMainTBL();
    const bookMainTBL = bookMainTBLData?.[currentUser.target] || {};
    const [missionType, setMissionType] = useState(COLLECTION_TYPE.COLLECTION);

    const collectionData = getCollectionData(playerData);
    const connectData = getConnectData(playerData);

    const columnData = useCallback(() => {
        switch (missionType) {
            case COLLECTION_TYPE.COLLECTION:
                return collectionData ? Object.values(collectionData) : [];
            case COLLECTION_TYPE.CONNECTION:
                return connectData ? Object.values(connectData) : [];
            default:
                return [];
        }
    }, [missionType, collectionData, connectData]);
    const columns = useMemo(() => [
        {
            title: missionType === COLLECTION_TYPE.COLLECTION ? '도감 분류' : '인연 분류',
            dataIndex: 'category',
            filters: [
                {
                    text: 'Merge',
                    value: '1',
                },
                {
                    text: 'Deco',
                    value: '2',
                },
                {
                    text: 'Actor',
                    value: '3',
                },
            ],
            onFilter: (value, record) => record.category === value,
            render: (_, {category}) => {
                switch (category) {
                    case '1':
                        return 'Merge';
                    case '2':
                        return 'Deco';
                    case '3':
                        return 'Actor';
                    default:
                        return 'Unknown';
                }
            }
        },
        {
            title: '그룹',
            dataIndex: 'group',
        },
        {
            title: '도감 항목명',
            dataIndex: 'index',
            render: (index) => bookMainTBL[index]?.nameText || '-',
        },
        {
            title: missionType === COLLECTION_TYPE.COLLECTION ? '도감 IDX' : '인연 IDX',
            dataIndex: 'index',
        },
        {
            title: '진행 단계',
            dataIndex: 'state',
            render: (_, {state}) => {
                let color, text;
                switch (state) {
                    case 0:
                        color = 'blue';
                        text = '진행 중';
                        break;
                    case 1:
                        color = 'green';
                        text = '완료';
                        break;
                    case 2:
                        color = 'purple';
                        text = '보상 수령';
                        break;
                    default:
                        color = 'lightgray';
                        text = 'Unknown';
                }
                return <Tag color={color}>{text}</Tag>;
            },
            filters: [
                {
                    text: '진행 중',
                    value: 0,
                },
                {
                    text: '완료',
                    value: 1,
                },
                {
                    text: '보상 수령',
                    value: 2,
                },
            ],
            onFilter: (value, record) => record.state === value,
        },
    ], [missionType]);

    return (
        <Card style={{margin: 8, padding: 8}}>
            <Space style={{marginBottom: 16, gap: 8}}>
                <Button
                    type={missionType === COLLECTION_TYPE.COLLECTION ? 'primary' : 'default'}
                    onClick={() => setMissionType(COLLECTION_TYPE.COLLECTION)}
                >
                    도감
                </Button>
                <Button
                    type={missionType === COLLECTION_TYPE.CONNECTION ? 'primary' : 'default'}
                    onClick={() => setMissionType(COLLECTION_TYPE.CONNECTION)}
                >
                    인연
                </Button>
            </Space>
            <Datatable columns={columns} rows={columnData()}/>
        </Card>
    );
};

export default Collection;